import { BasicWizardBasketStatusType } from '@wizard/types';

export const WizardBasketStatusList: BasicWizardBasketStatusType[] = [
  'New',
  'InProgress',
  'Validated',
  'Abandoned'
];
